import { FC } from "react"

export const Divider: FC = () => {
  return <div className="h-px bg-neutral-gray-300 w-full" />
}
